// src/App.js
import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext'; // Importante: Crie este arquivo depois

import Header from './components/Header';
import Footer from './components/Footer';
import AdminLayout from './components/AdminLayout';
import AdminRoute from './components/AdminRoute';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop';

// --- Páginas Públicas ---
// import Home from './pages/Home';
import HomeIntelbras from './pages/HomeIntelbras';
import CarregadoresVeiculares from './pages/CarregadoresVeiculares';
import Termos from './pages/Termos';
import Privacidade from './pages/Privacidade';
import Novotechnik from './pages/Novotechnik/Novotechnik';
import Dashboard from './pages/Dashboard';
import ProdutosIntelbras from './pages/ProdutosIntelbras';
import ProdutoDetalhe from './pages/ProdutoDetalhe';
import Carrinho from './pages/Carrinho';
import PosteCFTV from './pages/PosteCFTV';
import Servicos from './pages/Servicos';
import ParaSeuNegocio from './pages/ParaSeuNegocio';
import PaineisLED from './pages/PaineisLED';

// --- Páginas do Painel Admin ---
import AdminDashboard from './pages/AdminDashboard';
import AdminProdutosList from './pages/AdminProdutosList';
import AdminTools from './pages/AdminTools';
import AdminCategoriasList from './pages/AdminCategoriasList';
import ParaSeuCondominio from './pages/ParaSeuCondominio';
import AdminImportador from './pages/AdminImportador';
import AdminIntelbrasProdutosList from './pages/AdminIntelbrasProdutosList';
// Componente para agrupar páginas públicas
const PublicLayout = () => (
  <>
    <Header />
    <main>
      <Outlet /> {/* Agora o Outlet é reconhecido */}
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <AuthProvider>
      
      <ScrollToTop />
        <Routes>
          {/* ROTA PARA PÁGINAS PÚBLICAS */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<HomeIntelbras />} />
            <Route path="/solucoes/para-seu-condominio" element={<ParaSeuCondominio />} />
            <Route path="/para-seu-negocio" element={<ParaSeuNegocio />} />
            <Route path="/solucoes/carregadores-veiculares" element={<CarregadoresVeiculares />} />
            <Route path="/paineis-de-led" element={<PaineisLED />} />
            <Route path="/termos-e-condicoes" element={<Termos />} />
            <Route path="/politica-de-privacidade" element={<Privacidade />} />
            <Route path="/sensores/novotechnik" element={<Novotechnik />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/produtos/intelbras" element={<ProdutosIntelbras />} />
            <Route path="/solucoes/poste-cftv" element={<PosteCFTV />} />
            <Route path="/servicos" element={<Servicos />} />
            <Route path="/produtos/intelbras/:slug" element={<ProdutoDetalhe />} />
            <Route path="/carrinho" element={<Carrinho />} /> {/* Garanta que esta rota existe */}
          </Route>

          {/* ROTA PARA O PAINEL DE ADMINISTRAÇÃO */}
          <Route path="/admin" element={<AdminRoute />}>
          <Route element={<AdminLayout />}>
    <Route path="dashboard" element={<AdminDashboard />} />
    {/* Rota antiga renomeada */}
    <Route path="catalogo/novotechnik-produtos" element={<AdminProdutosList />} /> 
    {/* Nova Rota */}
    <Route path="catalogo/intelbras-produtos" element={<AdminIntelbrasProdutosList />} /> 
    <Route path="catalogo/categorias" element={<AdminCategoriasList />} />
    <Route path="catalogo/importador" element={<AdminImportador />} />
    <Route path="tools" element={<AdminTools />} />
</Route>
          </Route>
        </Routes>
        <WhatsAppButton />
      
    </AuthProvider>
  );
}

export default App;